import axios from 'axios'
// 后续代码可通过 process.env 访问变量
// const ApiRoot = 'http://localhost:8090/shop'
// export const resultEICurlHead = 'http://localhost:8081/pages/product/nxb/'
// 正式
// const ApiRoot = 'https://adminshop.gibbx.com/shop/'
// export const resultEICurlHead = 'https://bx.gibbx.com/pages/product/nxb/'
// 测试
const ApiRoot = 'https://admingf.yinbaohui.com.cn/shop/'
export const resultEICurlHead = 'https://h5.yinbaohui.com.cn/pages/product/nxb/'
// 创建axios实例，使用环境变量中的基础路径
const service = axios.create({
  baseURL: ApiRoot, // 从环境变量读取基础路径
  timeout: 5000, // 请求超时时间（5秒）
  headers: {
    'Content-Type': 'application/json'
  }
})

// 新增：短信接口专用实例（使用shop基础路径）
const shopService = axios.create({
  baseURL: ApiRoot, // 从环境变量读取shop接口基础路径
  timeout: 5000
})

// 请求拦截器（可选，如添加token）
service.interceptors.request.use(
  config => {
    // 示例：从localStorage获取token并添加到请求头
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器（可选，统一处理错误）
service.interceptors.response.use(
  response => {
    return response.data // 直接返回响应体数据
  },
  error => {
    // 示例：处理401未授权错误
    if (error.response.status === 401) {
      // alert('登录状态已过期，请重新登录')
      // 跳转到登录页...
    }
    return Promise.reject(error)
  }
)

export {service, shopService, ApiRoot}



// WEBPACK FOOTER //
// ./src/utils/axios.js